var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h4',{staticClass:"topped"},[_vm._v(" "+_vm._s(_vm.field.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }